import { useEffect, useState } from 'react';
import { getDocumentFilters } from 'api/documentApi';
import { getGPDocumentFilters } from 'api/group';

const useGetDocumentFilters = (isPracticeView = false, clientId?: number): [string[], { name: string; id: number }[], { name: string; id: number }[], () => Promise<void>] => {
    const [tags, setTags] = useState<string[]>([]);
    const [uploadedByOptions, setUploadedByOptions] = useState<{ name: string; id: number }[]>([]);
    const [visibleToOptions, setVisibleToOptions] = useState<{ name: string; id: number }[]>([]);

    const fetchDocumentFilters = async () => {
        const result = isPracticeView && clientId
            ? await getGPDocumentFilters(clientId)
            : await getDocumentFilters();
        if (!result.error) {
            setTags(result.data?.data?.tags || []);
            setUploadedByOptions(result.data?.data?.createdProviders?.map((item: { firstName: string; lastName: string; providerId: number }) => ({ name: `${item.firstName} ${item.lastName}`, id: item.providerId })) || []);
            setVisibleToOptions(result.data?.data?.visibleProviders?.map((item: { firstName: string; lastName: string; providerId: number }) => ({ name: `${item.firstName} ${item.lastName}`, id: item.providerId })) || []);
        }
    };
    useEffect(() => {
        fetchDocumentFilters();
    }, []);

    return [tags, uploadedByOptions, visibleToOptions, fetchDocumentFilters];
};

export default useGetDocumentFilters;
